export class Logger {
  private _debug: boolean;

  constructor() {
    this._debug = false;
  }

  set debug(value: boolean) {
    this._debug = value;
  }

  public printDebug(...args: any[]): void {
    if (!this._debug) return;
    console.debug("|| DqTag:", ...args);
  }

  public printError(...args: any[]): void {
    console.error("|| DqTag:", ...args);
  }
}
